import { getUrlParam } from '@common';

/**
 * 获取linkdata中的信息
 */
export const getLinkDataInfo = () => {
  try {
    const linkData = atob(getUrlParam('linkData'));
    return JSON.parse(linkData);
  } catch (error) {
    console.warn(error);
    return {};
  }
};

/**
 * 获取linkdata中的信息
 */
export const getLinkDataInfoValue = (key: string) => {
  try {
    const linkData = getLinkDataInfo();
    return linkData?.[key] || '';
  } catch (error) {
    console.warn(error);
    return '';
  }
};
